// Мови школи (accessType учня/вчителя/менеджера). За ними групуються учні/вчителі/пробні в кабінеті адміна з доступом "all".
// Нова мова — додати сюди і в бекенд utils/langs.js (ціни, чати).
// packages — ціни пакетів, грн (як на сайті); levels — рівні для форм, якщо в базі для групи їх ще немає;
// extraMaterials — розділ «Додаткові матеріали» (шпаргалки з граматики, поки лише англійські); teacherSalary — ЗП за урок за замовчуванням у формі вчителя;
// platformOnly — лише уроки платформи, без матеріалів Canva (ні перемикача, ні розділу).
export const langs = [
   {
     key: "en",
     value: "🇬🇧 Англійська",
     word: "англійською",
     packages: { 8: 3120, 16: 6000, 32: 11040, 50: 16250 },
     extraMaterials: true,
   },
   {
     key: "es",
     value: "🇪🇸 Іспанська",
     word: "іспанською",
     packages: { 8: 4200, 16: 8000, 32: 15200 },
     levels: ["A1", "A2", "B1", "B2"],
     teacherSalary: 225,
     platformOnly: true,
   },
 ];

export const langOf = (key) => langs.find((lang) => lang.key === key);
export const hasExtraMaterials = (key) => Boolean(langOf(key)?.extraMaterials);
export const isPlatformOnly = (key) => Boolean(langOf(key)?.platformOnly);
// Мова, яку школа зараз веде (німецька "de" — закрита, її записи лише в архіві)
export const isSchoolLang = (key) => Boolean(langOf(key));
export const packagePricesFor = (key) => (langOf(key) || langs[0]).packages;
